import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-zinc-950 border-t border-zinc-900 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <img
            src="/tidemark-logo.png"
            alt="Tidemark Building Co."
            className="h-8 w-auto object-contain"
          />
          <p className="mt-6 font-serif italic text-zinc-300 text-lg sm:text-xl leading-relaxed max-w-md">
            Let&apos;s build something you can&apos;t wait to come home to.
          </p>
        </div>

        <div>
          <div className="text-[11px] tracking-[0.25em] uppercase text-zinc-500 mb-4">
            Contact
          </div>
          <a
            href="mailto:info@tidemarkbuildingco.com.au"
            data-testid="footer-email"
            className="block text-zinc-200 hover:text-white transition-colors"
          >
            info@tidemarkbuildingco.com.au
          </a>
          <a
            href="tel:+61403863435"
            data-testid="footer-phone"
            className="block mt-2 text-zinc-200 hover:text-white transition-colors"
          >
            0403 863 435
          </a>
          <div className="mt-2 text-zinc-500 text-sm">
            Melbourne · Bayside, Victoria
          </div>
        </div>

        <div>
          <div className="text-[11px] tracking-[0.25em] uppercase text-zinc-500 mb-4">
            Navigate
          </div>
          <ul className="space-y-2 text-zinc-300 text-sm">
            <li>
              <Link
                to="/projects"
                data-testid="footer-link-projects"
                className="hover:text-white"
              >
                Projects
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                data-testid="footer-link-about"
                className="hover:text-white"
              >
                About
              </Link>
            </li>
            <li>
              <Link
                to="/process"
                data-testid="footer-link-process"
                className="hover:text-white"
              >
                Process
              </Link>
            </li>
            <li>
              <Link
                to="/services"
                data-testid="footer-link-services"
                className="hover:text-white"
              >
                Services
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                data-testid="footer-link-contact"
                className="hover:text-white"
              >
                Contact
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-zinc-900">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row justify-between gap-2 text-[11px] tracking-[0.2em] uppercase text-zinc-600">
          <div>© {new Date().getFullYear()} Tidemark Building Company</div>
          <Link
            to="/privacy"
            data-testid="footer-link-privacy"
            className="hover:text-zinc-300 transition-colors"
          >
            Privacy Policy
          </Link>
          <div>Registered Builder · Victoria, Australia</div>
        </div>
      </div>
    </footer>
  );
}
